import React from "react";
import GA from "../lib/ga";
import SurveyPopup from "./surveyPopup";

class SurveyWrap extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        GA.postRegistrationSurveyOpen()
        SurveyPopup.initPopup(this.props);
    }

    componentWillUnmount() {
        SurveyPopup.hide();
    }

    render() {
        return null;
    }
}

export default SurveyWrap;
